//通用函数
import smCom from '@/common/global/smCom.js';
//数字函数
import numHelper from '@/common/global/numHelper.js';
//时间函数
import timeHelper from '@/common/global/timeHelper.js';
// 参数完整判断
import routerParams from '@/common/global/routerParams.js';
// 全局变量
import global from '@/common/global/global.js';

// zmCloudApi
import zmCloudApi from '@/common/requset/zmCloudApi.js';

// 统一请求方法
import postApi from '@/common/requset/postApi.js';
import smSellApi from '@/common/requset/smSellApi.js';

export default {

	smCom, //通用函数
	numHelper, //数字函数
	timeHelper, //时间函数
	routerParams, // 判断参数是否完整
	global, // 全局变量
  smSellApi,
	postApi, // 统一请求方法

	zmCloudApi, // zmCloudApi

}



// WEBPACK FOOTER //
// ./src/common/bykApi.js